import { useRef } from 'react';

import { useIdentity } from '@zenbusiness/application-commons-identity';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { DownloadButton } from '#client/pages/EducationStudio/components/CustomPage/Buttergoat/ActivityCompletePage';
import {
  BottomSpacing, NextButton,
  SummaryCardContainer, TextWithBottomSpacing
} from '#client/pages/EducationStudio/components/Interactive/WorksheetActivity/worksheetComponents';
import { useBreakpoints, useLessonStorage } from '#client/pages/EducationStudio/hooks';
import { downloadCard } from '#client/pages/EducationStudio/utils/downloadCard';

import { SelectionCard } from '../../Interactive/BubbleSelectionActivity/InsideAlternative/selectionCard';
import { ExercisePage } from '../../Interactive/WorksheetActivity/exercisePage';
import { WHOS_YOUR_VIBE } from './whosYourVibe';

const NEXT_BUTTON_TEXT = 'Continue';

export const SummaryPage = ({ onNext }) => {
  const { lesson } = useParams();
  const { name } = useIdentity();

  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const cardRef = useRef();

  const { getStorageValue } = useLessonStorage(lesson);

  const isEmpty = (value) => value === '';
  const getStorageProp = (prop) => {
    const value = getStorageValue(prop);
    if (isEmpty(value)) return [];
    return value;
  };

  const userSelections = getStorageProp(WHOS_YOUR_VIBE);

  const items = userSelections.map((selection) => ({
    text: `${selection.title} - ${selection.text}`,
    bgColor: selection.color
  }));

  const presentation = (
    <>
      <SummaryCardContainer ref={cardRef}>
        <BottomSpacing>
          <SelectionCard
            user={name}
            items={items}
          />
        </BottomSpacing>
      </SummaryCardContainer>
      <SummaryCardContainer>
        <BottomSpacing>
          <DownloadButton
            variant="outlined"
            size="large"
            color="primary"
            onClick={() => downloadCard(cardRef.current, 'my_archetypes.png')}
          >
            Download
          </DownloadButton>
        </BottomSpacing>
      </SummaryCardContainer>
    </>
  );
  const summary = <TextWithBottomSpacing size="lg"> Keep these archetypes in mind, especially their strengths and weaknesses as you embark on your Journey to Success.</TextWithBottomSpacing>;

  return (
    <ExercisePage
      caption="Summary"
      title="Here are your top 3"
      summary={summary}
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      onNext={onNext}
    >
      {!isMobile && (
      <NextButton
        variant="contained"
        color="primary"
        size="large"
        onClick={() => onNext()}
      >
        {NEXT_BUTTON_TEXT}
      </NextButton>
      )}
    </ExercisePage>
  );
};

SummaryPage.propTypes = {
  onNext: PropTypes.func
};

SummaryPage.defaultProps = {
  onNext: () => {}
};

export default SummaryPage;
